// Zoho Invoice Types and Interfaces

export interface ZohoInvoice {
  invoiceId: string;
  zohoId: string;
  siteCode: string;
  type: string;
  invoiceNo: string;
  invoiceDate: string | null; // YYYY-MM-DD or null
  poNo: string;
  paymentDueDate: string | null; // YYYY-MM-DD or null
  quarter: string; // Q1, Q2, Q3, Q4
  amount: string;
  status: string; // paid, unpaid, overdue, pending
  createdAt: string;
  updatedAt: string;
  createdBy: string;
  createdByName?: string;
}

export interface CreateZohoInvoiceRequest {
  zohoId: string;
  siteCode: string;
  type: string;
  invoiceNo: string;
  invoiceDate: string;
  poNo: string;
  paymentDueDate: string;
  quarter: string;
  amount: string;
  status: string;
}

export interface UpdateZohoInvoiceRequest extends CreateZohoInvoiceRequest {
  invoiceId?: string;
}

export interface ZohoInvoiceFormData {
  zohoId: string;
  siteCode: string;
  type: string;
  invoiceNo: string;
  invoiceDate: string;
  poNo: string;
  paymentDueDate: string;
  quarter: string;
  amount: string;
  status: string;
}

export interface ZohoInvoiceResponse {
  invoiceRecords: ZohoInvoice[];
  totalCount: number;
  page: number;
  limit: number;
}

// Dropdown Options
export const SITE_CODE_OPTIONS = [
  { value: "A428", label: "A428 - Site Details" },
  { value: "A001", label: "A001" },
  { value: "A002", label: "A002" },
];

export const TYPE_OPTIONS = [
  { value: "AMC", label: "AMC" },
  { value: "Refilling", label: "Refilling" },
];

// Helper function to normalize type values
export const normalizeType = (type: string): string => {
  if (!type) return "";
  const normalized = type.toLowerCase();
  if (normalized === "amc") return "AMC";
  if (normalized === "refilling") return "Refilling";
  return type;
};

export const QUARTER_OPTIONS = [
  { value: "Q1", label: "Q1 (Jan-Mar)" },
  { value: "Q2", label: "Q2 (Apr-Jun)" },
  { value: "Q3", label: "Q3 (Jul-Sep)" },
  { value: "Q4", label: "Q4 (Oct-Dec)" },
];

export const STATUS_OPTIONS = [
  { value: "paid", label: "Paid" },
  { value: "unpaid", label: "Unpaid" },
  { value: "pending", label: "Pending" },
  { value: "overdue", label: "Overdue" },
];
